module.exports = __webpack_public_path__ + "static/media/cts_cladding.8fe913b0.jpg";